var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliceOfPizza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_624_3464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 4.52333C22.452 4.52333 27.5569 8.07888 29.0671 6.30111C29.2422 6.014 29.3346 5.71711 29.3346 5.41222C29.3346 3.63444 23.3649 0.967773 16.0013 0.967773C8.63775 0.967773 2.66797 3.63444 2.66797 5.41222C2.66797 5.71711 2.76041 6.014 2.93552 6.30111C4.44575 8.07888 9.55064 4.52333 16.0013 4.52333Z",
    fill: "#F4900C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 3.63428C10.4767 3.63428 6.56289 5.24317 5.09001 5.96139C4.66601 6.1685 4.61089 6.70806 4.72112 7.09739C4.83134 7.48672 14.2216 31.1898 14.2216 31.1898C14.2216 31.1898 15.018 32.9676 15.9993 32.9676C16.9807 32.9676 17.7771 31.1898 17.7771 31.1898L27.2918 6.99339C27.2918 6.99339 27.4811 6.24494 26.786 5.90094C25.2367 5.13561 21.3745 3.63428 15.9993 3.63428Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9979 28.5233C15.9979 26.5606 14.4059 24.9677 12.4423 24.9677C12.2166 24.9677 11.9979 24.9935 11.7837 25.0344L14.2201 31.1899C14.2201 31.1899 14.2832 31.3144 14.389 31.4939C15.357 30.8584 15.9979 29.7668 15.9979 28.5233ZM15.109 18.7455C15.109 16.7819 13.5161 15.1899 11.5534 15.1899C10.2859 15.1899 9.18011 15.8584 8.55078 16.8575L10.6503 22.1713C10.941 22.2477 11.2397 22.3011 11.5534 22.3011C13.5161 22.3011 15.109 20.7082 15.109 18.7455Z",
    fill: "#BE1931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2196 11.6345C16.1833 11.6345 17.7752 10.0427 17.7752 8.07899C17.7752 6.11531 16.1833 4.52344 14.2196 4.52344C12.2559 4.52344 10.6641 6.11531 10.6641 8.07899C10.6641 10.0427 12.2559 11.6345 14.2196 11.6345Z",
    fill: "#BE1931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.221 8.96799C20.2584 8.96799 18.6655 10.56 18.6655 12.5235C18.6655 14.4871 20.2584 16.0791 22.221 16.0791C22.8272 16.0791 23.3899 15.9129 23.8895 15.6453L25.5695 11.3733C25.0895 9.97688 23.7784 8.96799 22.221 8.96799ZM16.8877 23.1902C16.8877 24.8507 18.0326 26.2347 19.5712 26.6249L22.1428 20.0853C21.6361 19.8071 21.0628 19.6347 20.4432 19.6347C18.4806 19.6347 16.8877 21.2275 16.8877 23.1902ZM8.88769 11.6347C8.88769 9.6711 7.29569 8.0791 5.33214 8.0791C5.2548 8.0791 5.18191 8.09688 5.10547 8.10221C5.59436 9.35732 6.50547 11.672 7.57214 14.3751C8.36858 13.7227 8.88769 12.744 8.88769 11.6347Z",
    fill: "#BE1931"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_624_3464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.967773)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliceOfPizza);
export default __webpack_public_path__ + "static/media/slice-of-pizza.3edd15b45c706ce3715c8610545981da.svg";
export { ForwardRef as ReactComponent };